var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "white",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2375 4604 c-640 -70 -1177 -392 -1528 -918 -342 -512 -429 -1180 -231 -1776 214 -642 739 -1142 1392 -1324 198 -56 308 -70 557 -69 208 0 243 2 368 26 1231 240 1964 1484 1571 2667 -203 610 -689 1095 -1298 1295 -208 69 -372 96 -601 100 -104 2 -208 1 -230 -1z m359 -84 c704 -67 1307 -489 1606 -1123 352 -746 198 -1638 -385 -2223 -341 -342 -757 -533 -1255 -576 -167 -14 -361 -1 -543 37 -762 158 -1363 759 -1523 1523 -186 891 265 1793 1091 2183 313 147 670 211 1009 179z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1535 3389 c-85 -17 -175 -67 -241 -133 -163 -163 -187 -408 -58 -601 48 -74 103 -120 194 -163 67 -33 85 -37 171 -40 158 -7 264 34 368 142 100 105 136 202 129 355 -3 81 -8 106 -34 161 -61 129 -150 212 -277 259 -69 25 -182 34 -252 20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3420 3393 c-51 -8 -147 -47 -198 -80 -69 -46 -115 -101 -160 -192 -33 -67 -37 -83 -40 -172 -6 -152 35 -264 134 -363 99 -99 211 -140 363 -134 89 3 105 7 172 40 91 45 146 91 193 163 129 193 105 438 -58 601 -108 107 -263 160 -406 137z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2555 2299 c-178 -24 -369 -101 -512 -207 -95 -71 -225 -208 -254 -270 -20 -41 -21 -47 -8 -71 23 -40 71 -34 166 22 151 89 385 179 566 219 136 30 442 36 643 13 173 -20 201 -15 189 33 -9 39 -40 68 -130 123 -147 91 -299 136 -488 144 -56 2 -133 0 -172 -6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFace);
export default __webpack_public_path__ + "static/media/sadFace.28d5630c366e53bcd40371485b6a17e2.svg";
export { ForwardRef as ReactComponent };